import React from 'react';

type RoundButtonProps = {
    onMouseUp: (event: any) => void
    iconSvg: React.ReactNode
    type?: "button" | "submit" | "reset"
}

function RoundButton(props: RoundButtonProps) {
    const {onMouseUp, iconSvg, type = "button"} = props
    return (
        <button className="atoms-actions-roundbutton" onMouseUp={onMouseUp} type={type}>{iconSvg}</button>
    );
}

export default RoundButton;
